import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';

export type PriceDescProps = {
  price: string;
  discountedPrice: string | null;
};

export const PriceDesc = (p: PriceDescProps) => (
  <Typography
    variant="body"
    size="large"
    fontWeight="normal"
    className="text-left"
  >
    Price:{' '}
    <Typography
      as="span"
      className={clsx(p?.discountedPrice && 'line-through opacity-50')}
    >
      {p.price}
    </Typography>
    {p?.discountedPrice ? (
      <span>
        {' $'}
        {p.discountedPrice}
      </span>
    ) : null}
  </Typography>
);
